import {serializeFilters} from 'nutshell-core';
import type {ReportGap, FilterObject} from 'nutshell-core/types';

export type LandingPagesChartParams = {
    gap: ReportGap;
    pageId?: string;
};

export type LandingPagesReportPostParams = {
    filter: any;
    gap: ReportGap;
};

export function getLandingPagesReportPostParams(
    reportParams: LandingPagesChartParams,
    filters: FilterObject[]
): LandingPagesReportPostParams {
    const {gap, pageId} = reportParams;

    return {
        filter: serializeFilters(filters),
        gap,
        // @ts-expect-error
        pageId,
    };
}
